import React from 'react'
import PropTypes from 'prop-types'

const MARGIN_OPTIONS = {
    'no-margin': '0px',
    S: '10px',
    M: '25px',
}

const Row = (props) => {
    const { className = '', top = 'no-margin', bottom = 'no-margin'  } = props

    const style = {
        marginTop: MARGIN_OPTIONS[top],
        marginBottom: MARGIN_OPTIONS[bottom],
    }

    return (
        <div className={'row ' + className} style={style}>
            {props.children}
        </div>
    )
}

Row.propTypes = {
    className: PropTypes.string,
    top: PropTypes.string,
    bottom: PropTypes.string,
}

export default Row





// WEBPACK FOOTER //
// ./src/modules/bootstrap/component/Row.js